module.exports = __webpack_public_path__ + "static/media/Toolbar.b4152afe.png";